import {POST, GET} from "@/services/gateway";

const list = () => {
  return GET('google/user/backupsetings');
}

const updateAutoAdd = ({seatType, autoAdd}) => {
  return POST('google/user/backupsetings', {
    seatType, autoAdd
  })
}


export {
  list,
  updateAutoAdd
}
